import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Transforms plain-text @mention tokens (e.g. @user@domain.com)
 * into styled chip spans matching the crm-note mention-chip style.
 *
 * Usage: [innerHTML]="note.notes | mentionHighlight"
 */
@Pipe({ name: 'mentionHighlight', standalone: true })
export class MentionHighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return '';
    const escaped = value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
    // Match @anything (no whitespace) — covers emails like @user@domain.com
    const highlighted = escaped.replace(
      /@([^\s]+)/g,
      '<span class="mention-chip">@$1</span>'
    );
    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
